import React from 'react';
import { FlatList, StyleSheet, Text, View, } from 'react-native';
import { theme } from '../theme';
import { StaticRows } from './StaticRows';
/**
 * Current / prospect / completed name rows.
 * `bounded` keeps the desktop side-panel boxes. Otherwise rows are static so
 * the surrounding ScrollView can scroll them on iPhone Safari.
 */
export function ClientNameList({ data, renderItem, keyExtractor, bounded, frameStyle, emptyLabel, }) {
    if (!bounded) {
        return (<View style={frameStyle} testID="client-name-list">
        {data.length === 0 && emptyLabel ? (<Text style={styles.emptyList}>{emptyLabel}</Text>) : (<StaticRows data={data} renderItem={renderItem} keyExtractor={keyExtractor}/>)}
      </View>);
    }
    return (<View style={frameStyle} testID="client-name-list">
      <FlatList data={data} renderItem={renderItem} keyExtractor={keyExtractor} showsVerticalScrollIndicator ListEmptyComponent={emptyLabel ? (<Text style={styles.emptyList}>{emptyLabel}</Text>) : undefined}/>
    </View>);
}
const styles = StyleSheet.create({
    emptyList: {
        fontSize: 14,
        padding: 10,
        color: theme.colors.textSecondary,
    },
});
